<script setup lang="ts">
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import { highlightSubstring } from 'internal/highlight-substring'

import { SearchIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  iterator: string[]
  query: string | null
}>()
</script>

<template>
  <div class="prose-strong:font-sans-medium w-full flex-col bg-white">
    <a
      v-for="(item, index) in props.iterator"
      :key="index"
      class="hover:bg-gray-ultra-light pl-15 inline-flex min-h-9 w-full cursor-pointer items-center justify-start text-black"
      aria-label="search suggestion link"
      data-astro-reload
      :href="
        localizeUrl('/search/products', {
          q: item,
          suggestion: 'true',
        })
      "
    >
      <span class="inline-flex items-center space-x-2.5">
        <SearchIcon class="size-[16px] min-h-[16px] min-w-[16px] text-black" />
        <span
          class="text-sm"
          v-html="highlightSubstring(item, props.query)"
        />
      </span>
    </a>
  </div>
</template>
